__turbopack_context__.v({
  "helpCenterDrawer": "HelpCenter-module-scss-module__9FUynq__helpCenterDrawer",
  "helpCenterDropdown": "HelpCenter-module-scss-module__9FUynq__helpCenterDropdown",
  "helpCenterMenu": "HelpCenter-module-scss-module__9FUynq__helpCenterMenu",
  "helpCenterMenuDrawer": "HelpCenter-module-scss-module__9FUynq__helpCenterMenuDrawer",
  "helpCenterMenuDropdown": "HelpCenter-module-scss-module__9FUynq__helpCenterMenuDropdown",
  "itemContent": "HelpCenter-module-scss-module__9FUynq__itemContent",
  "itemTitle": "HelpCenter-module-scss-module__9FUynq__itemTitle",
  "itemWrapper": "HelpCenter-module-scss-module__9FUynq__itemWrapper",
  "menuItem": "HelpCenter-module-scss-module__9FUynq__menuItem",
});
